import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { NEW_RUN_SECTIONS } from '~/features/catalog-v2/types/new-run.types';

const NewRunPage = lazy(() => import('~/features/catalog-v2/pages/new-run-page'));

/** The K2 New batch page's active section, kept in the URL so a reload/back restores it.
 *  `copyFrom` (the Batch details rail's "Copy into a new batch") pre-applies that batch's own
 *  stored settings on load — the same resolution `NewRunCopyFromBatch`'s picker runs per click. */
const newRunSearchSchema = z.object({
  section: z.enum(NEW_RUN_SECTIONS).optional().catch(undefined),
  copyFrom: z.string().optional().catch(undefined),
});

/** New batch (P02, S11): server-driven K2 sidebar + form; on 202 it navigates to the new batch. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/new')({
  validateSearch: newRunSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <NewRunPage />
    </Suspense>
  ),
});
